export const ScheduleGroupType = {
    TRANSPORTS: 1
};

export const ScheduleGroupTypeList = [
    { id: 1, name: "Use For Transports" }
];